"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.radii = void 0;
var radii_1 = __importDefault(require("../tokens/radii"));
exports.radii = radii_1.default;
//# sourceMappingURL=radii.js.map